import { IdFilter } from "react3l-advanced-filters";
import { DateFilter } from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";
import { ObjectField } from "react3l-decorators";

export class ProjectParticipantFilter extends ModelFilter {
  @ObjectField(IdFilter)
  public id?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public projectId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public appUserId?: IdFilter = new IdFilter();
  @ObjectField(DateFilter)
  public startAt?: DateFilter = new DateFilter();
  @ObjectField(DateFilter)
  public endAt?: DateFilter = new DateFilter();
  @ObjectField(IdFilter)
  public roleId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public statusId?: IdFilter = new IdFilter();
  @ObjectField(DateFilter)
  public createdAt?: DateFilter = new DateFilter();
  @ObjectField(DateFilter)
  public updatedAt?: DateFilter = new DateFilter();
  @ObjectField(DateFilter)
  public effectiveTime?: DateFilter = new DateFilter();
  public search?: string = null;
  public positionId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public siteId?: IdFilter = new IdFilter();
}
